import type {ReactNode} from 'react';
import {createPortal} from 'react-dom';

export interface OverlayProps {
    portalContainer?: Element;
    children: ReactNode;
}

export const Overlay = ({portalContainer = document.body, children}: OverlayProps) => createPortal(children, portalContainer);
